import {SubscribeDataModel} from "@/models/request/SubscribeData.model";
import {ENVIRONMENT} from "@/consts/consts";

export const DEFAULT_SUBSCRIBE_DATA: SubscribeDataModel = {first_name: '', expert: '0',
    last_name: '', title: '', company: '', email: '', consent: '0', agenda: 'Brand', source: 'LP Lead Form',
    initial_Campaign__c : ENVIRONMENT.isProduction? '7012p000001f5yw' : '7011x00000039TK', campaign: 'brainpower'}
